export function getEntryRouterDecisionMeta(item) {
  return (item && item.meta && item.meta.entryRouter) || null
}

export function shortDecisionReason(reason, maxLength = 72) {
  const text = String(reason || '').trim()
  if (!text) return 'n/a'
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
}

export function formatDecisionModuleLabel(decisionModule) {
  return decisionModule === 'ENTRY_ROUTER'
    ? 'Entry Router'
    : (decisionModule || 'n/a')
}

export function outcomeHint(item) {
  const firstHit = String(item?.firstHit || '').toUpperCase()
  if (firstHit === 'TP') return 'ilk hit TP'
  if (firstHit === 'SL') return 'ilk hit SL'

  const wouldHitTp = Boolean(item?.wouldHitTp)
  const wouldHitSl = Boolean(item?.wouldHitSl)
  if (wouldHitTp && wouldHitSl) return 'TP + SL izi'
  if (wouldHitTp) return 'TP izi'
  if (wouldHitSl) return 'SL izi'
  return null
}

export function entryRouterDecisionLabel(item, maxLength = 72) {
  const reason = String(item?.decisionReason || '').toLowerCase()
  if (reason.startsWith('entry rr too low')) return 'RR düşük'
  if (reason.startsWith('entry score too low')) return 'Skor düşük'
  return shortDecisionReason(item?.decisionReason, maxLength)
}

export function entryRouterDecisionDetail(item, formatNum) {
  const meta = getEntryRouterDecisionMeta(item)
  const rr = Number(meta?.remainingRewardRisk ?? item?.remainingRewardRisk ?? 0)
  const score = Number(meta?.score ?? item?.entryScore ?? item?.signalScore ?? 0)
  const outcome = outcomeHint(item)
  const reason = String(item?.decisionReason || '').toLowerCase()

  if (reason.startsWith('entry rr too low')) {
    return `RR ${formatNum(rr, 2)} / min ${formatNum(meta?.effectiveMinRemainingRewardRisk || 0, 2)} · score ${formatNum(score, 2)}${outcome ? ` · ${outcome}` : ''}`
  }
  if (reason.startsWith('entry score too low')) {
    return `Score ${formatNum(score, 2)} / min ${formatNum(meta?.effectiveMinEntryScore || 0, 2)} · RR ${formatNum(rr, 2)}${outcome ? ` · ${outcome}` : ''}`
  }
  if (!meta && !outcome) return null
  return `Score ${formatNum(score, 2)} · RR ${formatNum(rr, 2)}${outcome ? ` · ${outcome}` : ''}`
}

export function outcomeMetricsDetail(item, formatNum, options = {}) {
  const mfe = Number(item?.decisionMfePct ?? item?.signalMfePct ?? 0)
  const mae = Number(item?.decisionMaePct ?? item?.signalMaePct ?? 0)
  const parts = [
    `MFE ${formatNum(mfe, 2)}%`,
    `MAE ${formatNum(mae, 2)}%`,
  ]

  const stickyAge = Number(item?.stickyAgeHours ?? item?.signalOutcome?.stickyAgeHours ?? 0)
  const stickyConfidence = Number(item?.stickyConfidence ?? item?.signalOutcome?.stickyConfidence ?? 0)
  if (Number.isFinite(stickyAge) && stickyAge > 0) {
    parts.push(`st ${formatNum(stickyAge, 1)}h`)
  }
  if (Number.isFinite(stickyConfidence) && stickyConfidence > 0) {
    parts.push(`cf ${formatNum(stickyConfidence, 2)}`)
  }

  const latePenalty = Number(options.latePenalty || 0)
  if (latePenalty > 0) {
    parts.push(`late ${formatNum(latePenalty, 2)}`)
  }

  return parts.join(' · ')
}

export function indicatorRecentDecisionLabel(item, maxLength = 48) {
  return `${formatDecisionModuleLabel(item?.decisionModule)} · ${entryRouterDecisionLabel(item, maxLength)}`
}

export function indicatorRecentDecisionContext(item, formatNum) {
  const score = Number(item?.entryScore ?? item?.signalScore ?? 0)
  const rr = Number(item?.remainingRewardRisk ?? 0)
  const parts = [
    `score ${formatNum(score, 2)}`,
  ]

  if (Number.isFinite(rr) && rr > 0) {
    parts.push(`RR ${formatNum(rr, 2)}`)
  }

  const outcome = outcomeHint(item)
  if (outcome) parts.push(outcome)
  const stickyAge = Number(item?.stickyAgeHours ?? item?.signalOutcome?.stickyAgeHours ?? 0)
  const stickyConfidence = Number(item?.stickyConfidence ?? item?.signalOutcome?.stickyConfidence ?? 0)
  if (Number.isFinite(stickyAge) && stickyAge > 0) parts.push(`st ${formatNum(stickyAge, 1)}h`)
  if (Number.isFinite(stickyConfidence) && stickyConfidence > 0) parts.push(`cf ${formatNum(stickyConfidence, 2)}`)
  return parts.join(' · ')
}

export function stickySelectionSummary(item, formatNum) {
  const stickyAge = Number(item?.stickyAgeHours ?? item?.signalOutcome?.stickyAgeHours ?? 0)
  const stickyConfidence = Number(item?.stickyConfidence ?? item?.signalOutcome?.stickyConfidence ?? 0)
  const agePart = Number.isFinite(stickyAge) && stickyAge > 0 ? `s${formatNum(stickyAge, 0)}` : null
  const confPart = Number.isFinite(stickyConfidence) && stickyConfidence > 0 ? `c${formatNum(stickyConfidence, 1)}` : null
  if (!agePart && !confPart) return null
  return agePart ? (confPart ? `${agePart}/${confPart}` : agePart) : confPart
}
